import _ from "lodash";
import { useEffect, useState } from "react";

import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

import ProgressProvider from "../../utils/ProgressProvider";
import { apiRequest } from "../../utils/api";
import { getLocalValue } from "../../utils/auth";

import styles from "./index.module.scss";

export default function RadialChart({
  variant = "medium",
  textAlign = "center",
  campaign = "",
  theme,
  updateChart,
  frequency,
  api,
  getCountryDetails,
  ...props
}) {
  const coach_id = getLocalValue("uid");
  const [percentage, setPercentage] = useState(0);
  const [labelDescription, setLabelDescription] = useState("");

  useEffect(() => {
    // get Team Dashboard Calendar details
    apiRequest
      .get(`/api/${api}`)
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          if (!_.isEmpty(data)) {
            setPercentage(data[props.average] ? data[props.average] : 0);
            const label = props.label
              .replace("{{chartValue}}", data[props.chartValue])
              .replace("{{secondParam}}", data[props.secondParam])
              .replace("{{totalValue}}", data[props.totalValue]);
            setLabelDescription(label);
            if (getCountryDetails) {
              getCountryDetails(data.countryDetails);
            }
          } else {
            setPercentage(0);
            const label = props.label
              .replace("{{chartValue}}", 0)
              .replace("{{totalValue}}", 0);
            setLabelDescription(label);
            getCountryDetails([]);
          }
        }
      })
      .catch(error => { });
  }, [frequency, updateChart, campaign, api, props.label]);

  return (
    <div
      className={`${styles.radialChart} ${variant === "small" && styles.smallVariant
        } ${textAlign === "left" ? styles.leftAlign : ""}`}
    >
      <h5>{props.title}</h5>
      <div
        style={{
          maxWidth: `${variant === "small" ? "95px" : "163px"}`,
          margin: `${textAlign === "left" ? "0" : "0 auto"}`,
        }}
      >
        <ProgressProvider valueStart={0} valueEnd={percentage}>
          {value => (
            <CircularProgressbar
              value={value}
              text={`${value}%`}
              strokeWidth="12"
              styles={{
                // Customize the root svg element
                root: {},
                // Customize the path, i.e. the "completed progress"
                path: {
                  // Path theme
                  stroke: theme,
                  // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                  strokeLinecap: "butt",
                  transition: "stroke-dashoffset 1s ease 0s",
                },
                // Customize the circle behind the path, i.e. the "total progress"
                trail: {
                  // Trail theme
                  stroke: "#EEEEEE",
                  // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                  strokeLinecap: "butt",
                },
                // Customize the text
                text: {
                  // Text theme
                  fill: theme,
                  // Text size
                  fontSize: "20px",
                  fontWeight: "700",
                  fontFamily: "Roboto",
                },
              }}
            />
          )}
        </ProgressProvider>
      </div>
      <label dangerouslySetInnerHTML={{ __html: labelDescription }}></label>
    </div>
  );
}
